export default __webpack_public_path__ + "static/media/user_placeholder.77d7ec1d.png";